
export default () => {
  // eslint-disable-next-line no-extend-native
  String.prototype.hashCode = function () {
    let hash = 0;
    let i;
    let chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = ((hash << 5) - hash) + chr;
      // eslint-disable-next-line no-bitwise
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  };


  HTMLElement.prototype.offsetLeftRelativeTo = function (elem) {
    let offset = 0;
    let it = this;

    try {
      // eslint-disable-next-line no-cond-assign
      do {
        offset += it.offsetLeft;
      } while (typeof it.offsetParent !== 'undefined' && (it = it.offsetParent) !== elem);
      // eslint-disable-next-line no-empty
    } catch (ignore) {
    }

    return offset;
  };
};



// WEBPACK FOOTER //
// ./src/lib/util/extend.js